var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_play") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_play",
    fill: "#31549B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,25 C5.59644063,25 8.45442189e-16,19.4035594 0,12.5 C-8.45442189e-16,5.59644063 5.59644063,1.26816328e-15 12.5,0 C19.4035594,-1.26816328e-15 25,5.59644063 25,12.5 C24.988988,19.3989929 19.3989929,24.988988 12.5,25 L12.5,25 Z M12.5,2 C6.70101013,2 2,6.70101013 2,12.5 C2,18.2989899 6.70101013,23 12.5,23 C18.2989899,23 23,18.2989899 23,12.5 C22.9944872,6.70329514 18.2967049,2.0055128 12.5,2 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "10.96 9.41 17.14 12.68 10.96 15.94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlay);
export default __webpack_public_path__ + "static/media/ic_play.f55683463efc90c6d3be94053f9a31d4.svg";
export { ForwardRef as ReactComponent };